import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { ClientEntity } from '@zerops/zerops/core/client-base';
import { zefDialogClose } from '@zerops/zef/dialog';
import { successOf } from '@zerops/zef/entities';
import { loadUser } from '@zerops/zerops/core/user-base';
import { FEATURE_NAME } from './client-add-dialog.constant';
import { ClientAddForm } from './client-add.form';
import { ZefSnackService } from '@zerops/zef/snack';

@Injectable()
export class ClientAddDialogEffect {
  #actions$ = inject(Actions);
  #client = inject(ClientEntity);
  #form = inject(ClientAddForm);
  #snack = inject(ZefSnackService);

  #onClientAddSuccess$ = this.#actions$.pipe(
    successOf<any>(this.#client.addOne)
  );

  onOrganizationSuccessCloseDialog$ = createEffect(() => this.#onClientAddSuccess$.pipe(
    mergeMap(() => [
      zefDialogClose({ key: FEATURE_NAME }),
      // Refresh User with new added Client
      loadUser()
    ])
  ));

  onDialogCloseResetForm$ = createEffect(() => this.#actions$.pipe(
    ofType(zefDialogClose),
    filter((action) => action?.key === FEATURE_NAME),
    switchMap(() => [
      this.#form.reset(),
      this.#form.setDefaultValues()
    ])
  ));

  onRemoveClientSuccessNotification$ = createEffect(() => this.#actions$.pipe(
    successOf<{ success: boolean; }>(this.#client.deleteOne),
    map(() => this.#snack.success$({ text: 'Client was successfully removed.'  }))
  ), { dispatch: false });

  onAddClientSuccessNotification$ = createEffect(() => this.#actions$.pipe(
    successOf<any>(this.#client.addOne),
    map(() => this.#snack.success$({ text: 'Client was successfully created.' }))
  ), { dispatch: false });
}
